import { QuestionnaireQuestion } from "../../Models/Surveys/SurveyDataModel";
import { BaseRegulationLogicManager } from "../BaseRegulationLogicManager";

export class GenericHideCustomLogicManager extends BaseRegulationLogicManager {
    protected getAdditionalQuestionIndicesToHide(question: QuestionnaireQuestion, questionIndex: number, indicesToHideOrShow: boolean[]) {
        for (let i = 0; i < this._questions.length; ++i) {
            indicesToHideOrShow[i] = this.shouldHideQuestion(this._questions[i], i)
        }

        return indicesToHideOrShow;
    }

    protected shouldHideQuestion(question: QuestionnaireQuestion, questionIndex: number) {
        return !this.isQuestionRequired(question);
    }
}
